var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PopupPosition, MarkAsReadModes } from './interfaces';
import timeAgo from './utils/timeAgo';
var defaultRestAPIUrl = 'https://api.notificationapi.com';
var defaultWebSocket = 'wss://ws.notificationapi.com';
var NOTIFICATION_REQUEST_COUNT = 50;
var PAGE_SIZE = 5;
function position(popup, popupInner, button, popupPosition) {
    var position = popupPosition.toString();
    var maxHeight = document.documentElement.clientHeight + 'px';
    var top = 'auto';
    var bottom = 'auto';
    var left = 'auto';
    var right = 'auto';
    if (window.innerWidth < 768) {
        top = -button.getBoundingClientRect().top + 'px';
        bottom =
            -(document.documentElement.clientHeight -
                button.getBoundingClientRect().bottom) + 'px';
        left = -button.getBoundingClientRect().left + 'px';
        right =
            -(document.documentElement.clientWidth -
                button.getBoundingClientRect().right) + 'px';
    }
    else {
        if (position.startsWith('top')) {
            bottom = button.clientHeight + 10 + 'px';
            maxHeight = button.getBoundingClientRect().top - 20 + 'px';
        }
        if (position.startsWith('bottom')) {
            bottom = 'auto';
            top = button.clientHeight + 10 + 'px';
            maxHeight =
                window.innerHeight - button.getBoundingClientRect().bottom - 40 + 'px';
        }
        if (position.startsWith('left')) {
            left = 'auto';
            right = button.clientWidth + 10 + 'px';
        }
        if (position.startsWith('right')) {
            right = 'auto';
            left = button.clientWidth + 10 + 'px';
        }
        if (position.endsWith('Top')) {
            top = 'auto';
            bottom = '0px';
            maxHeight = button.getBoundingClientRect().bottom - 20 + 'px';
        }
        if (position.endsWith('Bottom')) {
            bottom = 'auto';
            top = '0px';
            maxHeight =
                window.innerHeight - button.getBoundingClientRect().top - 40 + 'px';
        }
        if (position.endsWith('Left')) {
            left = 'auto';
            right = '0px';
        }
        if (position.endsWith('Right')) {
            right = 'auto';
            left = '0px';
        }
    }
    popup.style.top = top;
    popup.style.bottom = bottom;
    popup.style.left = left;
    popup.style.right = right;
    popupInner.style.maxHeight = maxHeight;
}
var NotificationAPIClient = (function () {
    function NotificationAPIClient(options) {
        var _this = this;
        var _a, _b;
        this.destroy = function () {
            var _a;
            (_a = _this.websocket) === null || _a === void 0 ? void 0 : _a.close();
            Object.values(_this.elements).map(function (e) {
                e && e.remove();
            });
        };
        this.identify = function (user) { return __awaiter(_this, void 0, void 0, function () {
            var _a, clientId, userId, userIdHash, url, authToken;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.state.initOptions, clientId = _a.clientId, userId = _a.userId, userIdHash = _a.userIdHash;
                        if (user.id && user.id !== userId) {
                            console.error("The userId \"".concat(user.id, "\" does not match the userId \"").concat(userId, "\" provided in the init options. Cancelling action to prevent mistakes."));
                            return [2];
                        }
                        url = "".concat(this.state.restBaseURL, "/").concat(encodeURIComponent(clientId), "/users/").concat(encodeURIComponent(userId));
                        authToken = 'Basic ' +
                            btoa("".concat(encodeURIComponent(clientId), ":").concat(encodeURIComponent(userId), ":").concat(userIdHash !== null && userIdHash !== void 0 ? userIdHash : ''));
                        return [4, fetch(url, {
                                body: JSON.stringify(user),
                                headers: {
                                    'content-type': 'application/json',
                                    Authorization: authToken
                                },
                                method: 'POST'
                            })];
                    case 1:
                        _b.sent();
                        return [2];
                }
            });
        }); };
        this.askForWebPushPermission = function () {
            if ('serviceWorker' in navigator) {
                navigator.serviceWorker
                    .register('/notificationapi-service-worker.js')
                    .then(function (registration) { return __awaiter(_this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_a) {
                        Notification.requestPermission().then(function (permission) { return __awaiter(_this, void 0, void 0, function () {
                            var _this = this;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(permission === 'granted')) return [3, 2];
                                        return [4, registration.pushManager
                                                .subscribe({
                                                userVisibleOnly: true,
                                                applicationServerKey: this.state.webPushSettings.applicationServerKey
                                            })
                                                .then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                                                var body;
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0:
                                                            body = {
                                                                webPushTokens: [
                                                                    {
                                                                        sub: {
                                                                            endpoint: res.toJSON().endpoint,
                                                                            keys: res.toJSON().keys
                                                                        }
                                                                    }
                                                                ]
                                                            };
                                                            return [4, this.identify(body)];
                                                        case 1:
                                                            _a.sent();
                                                            return [2];
                                                    }
                                                });
                                            }); })];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2];
                                }
                            });
                        }); });
                        return [2];
                    });
                }); });
            }
        };
        this.showInApp = function (options) {
            var _a;
            _this.state.inappOptions = options;
            var root = document.getElementById(options.root);
            if (!root) {
                console.error("There are no HTML elements with id=\"".concat(options.root, "\" on the page."));
                return;
            }
            _this.elements.root = root;
            if (options.popupPosition &&
                !Object.values(PopupPosition).includes(options.popupPosition)) {
                console.error("\"".concat(options.popupPosition, "\" is not a valid position. Valid positions: ").concat(Object.values(PopupPosition).join(', ')));
                return;
            }
            if (root.hasChildNodes()) {
                root.innerHTML = '';
            }
            var container = document.createElement('div');
            container.classList.add('notificationapi-container');
            root.appendChild(container);
            _this.elements.popup = document.createElement('div');
            var popup = _this.elements.popup;
            popup.classList.add('notificationapi-popup');
            if (options.inline) {
                popup.classList.add('inline');
            }
            else {
                popup.classList.add('popup');
                popup.classList.add('hovering');
                popup.classList.add('closed');
                var button = document.createElement('button');
                button.classList.add('notificationapi-button');
                button.innerHTML = "<span class=\"icon-bell-o\"></span>";
                container.appendChild(button);
                button.onclick = function () {
                    if (popup.classList.contains('closed')) {
                        _this.openInAppPopup();
                    }
                    else {
                        _this.closeInAppPopup();
                    }
                };
                _this.elements.button = button;
                window.addEventListener('click', function (e) {
                    var _a, _b, _c;
                    var clickedPopup = (_a = e.target.closest('.notificationapi-popup')) !== null && _a !== void 0 ? _a : false;
                    var clickedButton = (_b = e.target.closest('.notificationapi-button')) !== null && _b !== void 0 ? _b : false;
                    var clickedPreferences = (_c = e.target.closest('.notificationapi-preferences-container')) !== null && _c !== void 0 ? _c : false;
                    if (!clickedButton &&
                        !clickedPopup &&
                        !clickedPreferences &&
                        !_this.elements.notificationMenu) {
                        popup.classList.add('closed');
                    }
                });
                var unread = document.createElement('div');
                unread.classList.add('notificationapi-unread');
                button.appendChild(unread);
                _this.elements.unread = unread;
                _this.setInAppUnread(_this.state.unread);
            }
            container.appendChild(popup);
            window.addEventListener('click', function (e) {
                var _a;
                var clickedNotificationMenuButton = (_a = e.target.closest('.notificationapi-notification-menu-button')) !== null && _a !== void 0 ? _a : false;
                if (!clickedNotificationMenuButton && _this.elements.notificationMenu) {
                    _this.elements.notificationMenu.remove();
                    _this.elements.notificationMenu = undefined;
                }
            });
            _this.elements.popupInner = document.createElement('div');
            var popupInner = _this.elements.popupInner;
            popupInner.classList.add('notificationapi-popup-inner');
            popup.appendChild(popupInner);
            _this.elements.popupInner = popupInner;
            _this.elements.header = document.createElement('div');
            var headerCloseButton = document.createElement('button');
            headerCloseButton.classList.add('notificationapi-close-button');
            headerCloseButton.addEventListener('click', function () {
                _this.closeInAppPopup();
            });
            _this.elements.header.appendChild(headerCloseButton);
            var headerHeading = document.createElement('h1');
            headerHeading.innerHTML = 'Notifications';
            _this.elements.header.appendChild(headerHeading);
            var headerPreferencesButton = document.createElement('button');
            headerPreferencesButton.classList.add('notificationapi-preferences-button');
            headerPreferencesButton.innerHTML = '<span class="icon-cog"></span>';
            headerPreferencesButton.title = 'Notification Settings';
            headerPreferencesButton.addEventListener('click', function () {
                _this.showUserPreferences();
            });
            _this.elements.header.appendChild(headerPreferencesButton);
            if (options.markAsReadMode &&
                options.markAsReadMode !== MarkAsReadModes.AUTOMATIC) {
                var headerReadAllButton = document.createElement('button');
                headerReadAllButton.classList.add('notificationapi-readAll-button');
                headerReadAllButton.innerHTML = '<span class="icon-check"></span>';
                headerReadAllButton.title = 'Mark all as read';
                headerReadAllButton.addEventListener('click', function () {
                    _this.readAll();
                });
                _this.elements.header.appendChild(headerReadAllButton);
            }
            _this.elements.header.classList.add('notificationapi-header');
            popupInner.appendChild(_this.elements.header);
            var loading = document.createElement('div');
            loading.classList.add('notificationapi-loading');
            var icon = document.createElement('span');
            icon.classList.add('icon-spinner8', 'spinner');
            loading.appendChild(icon);
            popupInner.appendChild(loading);
            _this.elements.notificationsLoading = loading;
            _this.elements.footer = document.createElement('div');
            if (options.paginated) {
                _this.state.pageSize = (_a = options.pageSize) !== null && _a !== void 0 ? _a : PAGE_SIZE;
                var prevButton = document.createElement('button');
                prevButton.classList.add('notificationapi-prev-button');
                prevButton.innerHTML = '<';
                prevButton.disabled = true;
                prevButton.addEventListener('click', function () {
                    _this.changePage(_this.state.currentPage - 1);
                });
                _this.elements.prevButton = prevButton;
                var nextButton = document.createElement('button');
                nextButton.classList.add('notificationapi-next-button');
                nextButton.innerHTML = '>';
                nextButton.disabled = true;
                nextButton.addEventListener('click', function () {
                    _this.changePage(_this.state.currentPage + 1);
                });
                _this.elements.nextButton = nextButton;
                _this.elements.footer.appendChild(prevButton);
                _this.elements.footer.appendChild(nextButton);
            }
            _this.elements.footer.classList.add('notificationapi-footer');
            popupInner.appendChild(_this.elements.footer);
            _this.addNotificationsToState(_this.state.notifications);
            if (!options.paginated) {
                popupInner.onscroll = function () {
                    if (popupInner.scrollTop + popupInner.clientHeight >=
                        popupInner.scrollHeight - 100) {
                        _this.requestMoreNotifications();
                    }
                };
            }
            _this.sendWSMessage({
                route: 'inapp_web/unread_count'
            });
            _this.sendWSMessage({
                route: 'inapp_web/notifications',
                payload: {
                    count: NOTIFICATION_REQUEST_COUNT
                }
            });
            if (_this.websocket) {
                var ws = _this.websocket;
                ws.addEventListener('message', function (m) {
                    var body = JSON.parse(m.data);
                    if (!body || !body.route) {
                        return;
                    }
                    if (body.route === 'inapp_web/unread_count') {
                        var message = body;
                        _this.websocketHandlers.unreadCount(message);
                    }
                    if (body.route === 'inapp_web/notifications') {
                        var message = body;
                        _this.websocketHandlers.notifications(message);
                    }
                    if (body.route === 'inapp_web/new_notifications') {
                        var message = body;
                        _this.websocketHandlers.newNotifications(message);
                    }
                });
            }
        };
        this.elements = {};
        this.state = {
            initOptions: options,
            lastNotificationsRequestAt: 0,
            notifications: [],
            unread: 0,
            oldestNotificationsDate: '',
            currentPage: 0,
            pageSize: 999999,
            webPushSettings: {
                applicationServerKey: '',
                askForWebPushPermission: false
            },
            restBaseURL: (_a = options.restBaseURL) !== null && _a !== void 0 ? _a : defaultRestAPIUrl
        };
        this.websocketHandlers = {
            notifications: function (message) {
                var notifications = message.payload.notifications;
                _this.state.lastResponseNotificationsCount = notifications.length;
                if (_this.elements.notificationsLoading) {
                    _this.elements.notificationsLoading.remove();
                    delete _this.elements.notificationsLoading;
                }
                _this.addNotificationsToState(notifications);
                if (notifications.length < NOTIFICATION_REQUEST_COUNT &&
                    !_this.elements.empty &&
                    _this.elements.popupInner) {
                    if (_this.state.inappOptions && !_this.state.inappOptions.paginated) {
                        var noMore = document.createElement('div');
                        noMore.innerHTML = 'No more notifications to load';
                        noMore.classList.add('notificationapi-nomore');
                        _this.elements.popupInner.append(noMore);
                    }
                }
                _this.renderNotifications();
            },
            newNotifications: function (message) {
                var beforeCount = _this.state.notifications.length;
                if (_this.elements.notificationsLoading) {
                    _this.elements.notificationsLoading.remove();
                    delete _this.elements.notificationsLoading;
                }
                _this.addNotificationsToState(message.payload.notifications);
                _this.renderNotifications();
                var afterCount = _this.state.notifications.length;
                _this.setInAppUnread(_this.state.unread + afterCount - beforeCount);
            },
            unreadCount: function (message) {
                _this.setInAppUnread(message.payload.count);
            },
            userPreferences: function (message) {
                if (_this.elements.preferencesLoading) {
                    _this.elements.preferencesLoading.remove();
                    delete _this.elements.preferencesLoading;
                }
                _this.renderPreferences(message.payload.userPreferences);
            }
        };
        if (!options.clientId || options.clientId === 'undefined') {
            console.error('Invalid clientId.');
            return;
        }
        if (!options.userId || options.userId === 'undefined') {
            console.error('Invalid userId.');
            return;
        }
        if (options.websocket !== false) {
            var websocketAddress = "".concat((_b = options.websocket) !== null && _b !== void 0 ? _b : defaultWebSocket, "?envId=").concat(encodeURIComponent(options.clientId), "&userId=").concat(encodeURIComponent(options.userId)).concat(options.userIdHash
                ? '&userIdHash=' + encodeURIComponent(options.userIdHash)
                : '');
            this.websocket = new WebSocket(websocketAddress);
            this.websocket.addEventListener('message', function (m) {
                var body = JSON.parse(m.data);
                if (!body || !body.route) {
                    return;
                }
                if (body.route === 'environment/data') {
                    var message = body;
                    _this.state.webPushSettings.applicationServerKey =
                        message.payload.applicationServerKey;
                    if ('Notification' in window &&
                        Notification.permission === 'granted') {
                        _this.state.webPushSettings.askForWebPushPermission = false;
                    }
                    else {
                        _this.state.webPushSettings.askForWebPushPermission =
                            message.payload.askForWebPushPermission;
                        _this.state.webPushSettings.askForWebPushPermission
                            ? _this.renderWebPushOptIn()
                            : null;
                    }
                }
            });
            this.sendWSMessage({
                route: 'environment/data'
            });
        }
    }
    NotificationAPIClient.prototype.requestMoreNotifications = function () {
        if (this.websocket &&
            new Date().getTime() - this.state.lastNotificationsRequestAt >= 500 &&
            (this.state.lastResponseNotificationsCount === undefined ||
                this.state.lastResponseNotificationsCount >= NOTIFICATION_REQUEST_COUNT)) {
            this.state.lastNotificationsRequestAt = new Date().getTime();
            var moreNotificationsRequest = {
                route: 'inapp_web/notifications',
                payload: {
                    before: this.state.oldestNotificationsDate,
                    count: NOTIFICATION_REQUEST_COUNT
                }
            };
            this.sendWSMessage(moreNotificationsRequest);
        }
    };
    NotificationAPIClient.prototype.showUserPreferences = function (options) {
        var _this = this;
        if (!this.elements.preferencesContainer) {
            var root = document.getElementsByTagName('body')[0];
            if (options === null || options === void 0 ? void 0 : options.parent) {
                var parentElement = document.getElementById(options.parent);
                if (!parentElement) {
                    console.error("There are no HTML elements with id=\"".concat(options.parent, "\" on the page."));
                }
                else {
                    root = parentElement;
                }
            }
            var container_1 = document.createElement('div');
            container_1.classList.add('notificationapi-preferences-container');
            if (options === null || options === void 0 ? void 0 : options.parent)
                container_1.classList.add('inline');
            this.elements.preferencesContainer = container_1;
            root.appendChild(container_1);
            var backdrop = document.createElement('div');
            backdrop.classList.add('notificationapi-preferences-backdrop');
            backdrop.addEventListener('click', function () {
                container_1.classList.add('closed');
            });
            container_1.appendChild(backdrop);
            var popup = document.createElement('div');
            popup.classList.add('notificationapi-preferences-popup');
            container_1.appendChild(popup);
            this.elements.preferencesPopup = popup;
            var close_1 = document.createElement('button');
            close_1.classList.add('notificationapi-preferences-close');
            close_1.addEventListener('click', function () {
                container_1.classList.add('closed');
            });
            popup.appendChild(close_1);
            var title = document.createElement('h1');
            title.innerHTML = 'Notification Preferences';
            popup.appendChild(title);
            if (this.state.webPushSettings.askForWebPushPermission) {
                var message = document.createElement('p');
                message.innerHTML = "<a href=\"#\" class=\"click-here\">Click here</a> to give us the necessary browser permissions to send you push notifications.";
                message.classList.add('notificationapi-preferences-web-push-opt-in');
                popup.appendChild(message);
                message.addEventListener('click', function (event) {
                    event.preventDefault();
                    _this.askForWebPushPermission();
                });
            }
            var loading = document.createElement('div');
            loading.classList.add('notificationapi-loading');
            var icon = document.createElement('span');
            icon.classList.add('icon-spinner8', 'spinner');
            loading.appendChild(icon);
            popup.appendChild(loading);
            this.elements.preferencesLoading = loading;
            if (this.websocket) {
                var ws = this.websocket;
                ws.addEventListener('message', function (m) {
                    var body = JSON.parse(m.data);
                    if (!body || !body.route) {
                        return;
                    }
                    if (body.route === 'user_preferences/preferences') {
                        var message = body;
                        _this.websocketHandlers.userPreferences(message);
                    }
                });
            }
        }
        else {
            this.elements.preferencesContainer.classList.remove('closed');
        }
        this.sendWSMessage({
            route: 'user_preferences/get_preferences'
        });
    };
    NotificationAPIClient.prototype.getUserPreferences = function () {
        return __awaiter(this, void 0, void 0, function () {
            var message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.sendWSMessage({
                            route: 'user_preferences/get_preferences'
                        });
                        return [4, this.websocketMessageReceived('user_preferences/preferences')];
                    case 1:
                        message = (_a.sent());
                        return [2, message.payload.userPreferences];
                }
            });
        });
    };
    NotificationAPIClient.prototype.patchUserPreference = function (notificationId, channel, state, subNotificationId) {
        var message = {
            route: 'user_preferences/patch_preferences',
            payload: [
                {
                    notificationId: notificationId,
                    channelPreferences: [
                        {
                            channel: channel,
                            state: state
                        }
                    ]
                }
            ]
        };
        if (subNotificationId) {
            message.payload[0].subNotificationId = subNotificationId;
        }
        this.sendWSMessage(message);
    };
    NotificationAPIClient.prototype.openInAppPopup = function () {
        var _a;
        if (this.elements.popup &&
            this.elements.popupInner &&
            this.elements.button &&
            this.state.inappOptions &&
            !this.state.inappOptions.inline) {
            position(this.elements.popup, this.elements.popupInner, this.elements.button, (_a = this.state.inappOptions.popupPosition) !== null && _a !== void 0 ? _a : PopupPosition.RightBottom);
            this.elements.popup.classList.remove('closed');
            if (!this.state.inappOptions.markAsReadMode ||
                this.state.inappOptions.markAsReadMode === MarkAsReadModes.AUTOMATIC) {
                this.readAll();
            }
        }
    };
    NotificationAPIClient.prototype.readAll = function () {
        this.setInAppUnread(0);
        this.state.notifications.map(function (n) {
            n.seen = true;
        });
        this.sendWSMessage({
            route: 'inapp_web/unread_clear'
        });
        if (this.state.inappOptions &&
            this.state.inappOptions.markAsReadMode &&
            this.state.inappOptions.markAsReadMode !== MarkAsReadModes.AUTOMATIC &&
            this.elements.popupInner) {
            this.elements.popupInner.querySelectorAll('.unseen').forEach(function (e) {
                e.classList.remove('unseen');
            });
        }
    };
    NotificationAPIClient.prototype.closeInAppPopup = function () {
        if (this.elements.popup &&
            this.state.inappOptions &&
            !this.state.inappOptions.inline) {
            this.elements.popup.classList.add('closed');
        }
    };
    NotificationAPIClient.prototype.setInAppUnread = function (count) {
        this.state.unread = count;
        if (this.elements.unread &&
            this.state.inappOptions &&
            !this.state.inappOptions.inline) {
            if (count === 0) {
                this.elements.unread.classList.add('hidden');
            }
            else {
                this.elements.unread.classList.remove('hidden');
            }
            if (count < 100) {
                this.elements.unread.innerHTML = count + '';
            }
            else {
                this.elements.unread.innerHTML = '+99';
            }
        }
    };
    NotificationAPIClient.prototype.addNotificationsToState = function (notifications) {
        var _this = this;
        var newNotifications = notifications.filter(function (n) {
            var found = _this.state.notifications.find(function (existingN) {
                return existingN.id === n.id;
            });
            return found ? false : true;
        });
        this.state.notifications =
            this.state.notifications.concat(newNotifications);
        this.state.notifications.sort(function (a, b) {
            return Date.parse(b.date) - Date.parse(a.date);
        });
        if (this.state.notifications.length > 0)
            this.state.oldestNotificationsDate =
                this.state.notifications[this.state.notifications.length - 1].date;
        if (this.state.notifications.length === 0 &&
            !this.elements.empty &&
            !this.elements.notificationsLoading &&
            this.elements.header) {
            var empty = document.createElement('div');
            empty.classList.add('notificationapi-empty');
            empty.innerHTML = "You don't have any notifications!";
            this.elements.header.after(empty);
            this.elements.empty = empty;
        }
        if (newNotifications.length > 0 && this.elements.empty) {
            this.elements.empty.remove();
            delete this.elements.empty;
        }
    };
    NotificationAPIClient.prototype.getPageCount = function () {
        return Math.max(1, Math.ceil(this.state.notifications.length / this.state.pageSize));
    };
    NotificationAPIClient.prototype.changePage = function (pageNumber) {
        this.state.currentPage = pageNumber;
        if (this.state.currentPage >= this.getPageCount() - 2) {
            this.requestMoreNotifications();
        }
        this.renderNotifications();
    };
    NotificationAPIClient.prototype.renderNotifications = function () {
        var header = this.elements.header;
        var popupInner = this.elements.popupInner;
        if (!header || !popupInner || !this.state.inappOptions)
            return;
        var page = this.state.currentPage;
        var pageSize = this.state.pageSize;
        if (this.state.inappOptions.paginated) {
            popupInner
                .querySelectorAll('.notificationapi-notification')
                .forEach(function (el) {
                el.remove();
            });
        }
        for (var i = page * pageSize; i < this.state.notifications.length && i < page * pageSize + pageSize; i++) {
            var n = this.state.notifications[i];
            if (popupInner.querySelector("[data-notification-id=\"".concat(n.id, "\"]"))) {
                continue;
            }
            var el = this.generateNotificationElement(n);
            if (i === page * pageSize) {
                header.insertAdjacentElement('afterend', el);
            }
            else {
                var preNotificationEl = popupInner.querySelector("[data-notification-id=\"".concat(this.state.notifications[i - 1].id, "\"]"));
                if (preNotificationEl) {
                    preNotificationEl.insertAdjacentElement('afterend', el);
                }
                else {
                    console.error('error finding previous notification', this.state.notifications[i - 1]);
                }
            }
        }
        if (this.elements.prevButton) {
            this.elements.prevButton.disabled = page === 0;
        }
        if (this.elements.nextButton) {
            this.elements.nextButton.disabled =
                page >= this.state.notifications.length / pageSize - 1;
        }
    };
    NotificationAPIClient.prototype.generateNotificationElement = function (n) {
        var _this = this;
        var notification = document.createElement('a');
        notification.setAttribute('data-notification-id', n.id);
        notification.classList.add('notificationapi-notification');
        if (n.redirectURL) {
            notification.href = n.redirectURL;
        }
        var notificationImageContainer = document.createElement('div');
        notificationImageContainer.classList.add('notificationapi-notification-imageContainer');
        if (n.imageURL) {
            var notificationImage = document.createElement('img');
            notificationImage.classList.add('notificationapi-notification-image');
            notificationImage.src = n.imageURL;
            notificationImageContainer.appendChild(notificationImage);
        }
        else {
            var notificationIcon = document.createElement('span');
            notificationIcon.classList.add('icon-commenting-o');
            notificationIcon.classList.add('notificationapi-notification-defaultIcon');
            notificationImageContainer.appendChild(notificationIcon);
        }
        notification.appendChild(notificationImageContainer);
        var notificationMetaContainer = document.createElement('div');
        notificationMetaContainer.classList.add('notificationapi-notification-metaContainer');
        var notificationTitle = document.createElement('p');
        notificationTitle.classList.add('notificationapi-notification-title');
        notificationTitle.innerHTML = n.title;
        notificationMetaContainer.appendChild(notificationTitle);
        var date = document.createElement('p');
        date.classList.add('notificationapi-notification-date');
        date.innerHTML = timeAgo(Date.now() - new Date(n.date).getTime());
        notificationMetaContainer.appendChild(date);
        notification.appendChild(notificationMetaContainer);
        if (!n.seen) {
            notification.classList.add('unseen');
        }
        if (this.state.inappOptions &&
            this.state.inappOptions.markAsReadMode &&
            this.state.inappOptions.markAsReadMode !== MarkAsReadModes.AUTOMATIC) {
            var menuButton = document.createElement('button');
            menuButton.classList.add('notificationapi-notification-menu-button');
            menuButton.innerHTML = '<span class="icon-ellipsis-h"></span>';
            menuButton.addEventListener('click', function (e) {
                var _a;
                e.preventDefault();
                (_a = _this.elements.notificationMenu) === null || _a === void 0 ? void 0 : _a.remove();
                var menu = document.createElement('div');
                menu.classList.add('notificationapi-notification-menu');
                var item = document.createElement('button');
                item.classList.add('notificationapi-notification-menu-item');
                item.innerHTML =
                    '<span class="icon-check"></span><span class="notificationapi-notification-menu-item-text">Mark as read</span>';
                item.addEventListener('click', function (e) {
                    e.preventDefault();
                    notification.classList.remove('unseen');
                    _this.setInAppUnread(_this.state.unread - 1);
                    _this.sendWSMessage({
                        route: 'inapp_web/unread_clear',
                        payload: {
                            notificationId: n.id
                        }
                    });
                });
                menu.appendChild(item);
                notification.appendChild(menu);
                _this.elements.notificationMenu = menu;
            });
            notification.appendChild(menuButton);
        }
        if (this.state.inappOptions &&
            this.state.inappOptions.markAsReadMode ===
                MarkAsReadModes.MANUAL_AND_CLICK) {
            notification.addEventListener('click', function (e) {
                var element = e.target;
                var menuWasClicked = element.classList.contains('notificationapi-notification-menu-button') ||
                    element.classList.contains('notificationapi-notification-menu') ||
                    element.closest('.notificationapi-notification-menu-button') ||
                    element.closest('.notificationapi-notification-menu');
                if (!menuWasClicked) {
                    notification.classList.remove('unseen');
                    _this.setInAppUnread(_this.state.unread - 1);
                    _this.sendWSMessage({
                        route: 'inapp_web/unread_clear',
                        payload: {
                            notificationId: n.id
                        }
                    });
                }
            });
        }
        return notification;
    };
    NotificationAPIClient.prototype.renderPreferences = function (preferences) {
        var _this = this;
        var _a;
        if (!this.elements.preferencesPopup)
            return;
        var popup = this.elements.preferencesPopup;
        var validPreferences = preferences.filter(function (p) { return p.settings.length > 0; });
        if (validPreferences.length === 0 && !this.elements.preferencesEmpty) {
            var empty = document.createElement('div');
            empty.classList.add('notificationapi-preferences-empty');
            empty.innerHTML = 'There are no notifications to configure.';
            popup.appendChild(empty);
            this.elements.preferencesEmpty = empty;
            return;
        }
        (_a = this.elements.preferencesGrid) === null || _a === void 0 ? void 0 : _a.remove();
        this.elements.preferencesGrid = undefined;
        var grid = document.createElement('div');
        grid.classList.add('notificationapi-preferences-grid');
        this.elements.preferencesGrid = grid;
        popup.appendChild(grid);
        var channels = {};
        validPreferences.map(function (p) {
            p.settings.map(function (s) {
                if (!channels[s.channel])
                    channels[s.channel] = s.channelName;
            });
        });
        var row = 1;
        Object.values(channels).map(function (v, i) {
            var channel = document.createElement('div');
            channel.innerHTML = v;
            channel.classList.add('notificationapi-preferences-channel', "notificationapi-preferences-col".concat(i + 2), "notificationapi-preferences-row".concat(row));
            grid.appendChild(channel);
        });
        row++;
        validPreferences.map(function (pref) {
            var title = document.createElement('div');
            title.classList.add('notificationapi-preferences-title', 'notificationapi-preferences-col1', "notificationapi-preferences-row".concat(row));
            title.innerHTML = pref.title;
            grid.appendChild(title);
            pref.settings.map(function (s) {
                var toggle = document.createElement('div');
                var col = Object.keys(channels).indexOf(s.channel) + 2;
                toggle.classList.add('notificationapi-preferences-toggle', "notificationapi-preferences-col".concat(col), "notificationapi-preferences-row".concat(row));
                toggle.setAttribute('data-notificationId', pref.notificationId);
                toggle.setAttribute('data-channel', s.channel);
                var label = document.createElement('label');
                label.classList.add('switch');
                toggle.appendChild(label);
                var input = document.createElement('input');
                input.setAttribute('type', 'checkbox');
                input.checked = s.state;
                label.appendChild(input);
                var i = document.createElement('i');
                label.appendChild(i);
                input.addEventListener('change', function () {
                    grid
                        .querySelectorAll(".notificationapi-preferences-subtoggle[data-notificationid=\"".concat(pref.notificationId, "\"][data-channel=\"").concat(s.channel, "\"] input"))
                        .forEach(function (e) {
                        e.disabled = !input.checked;
                    });
                    _this.patchUserPreference(pref.notificationId, s.channel, input.checked);
                });
                grid.appendChild(toggle);
            });
            row++;
            if (pref.subNotificationPreferences &&
                pref.subNotificationPreferences.length > 0) {
                var expand = document.createElement('button');
                expand.innerHTML = 'expand';
                expand.setAttribute('data-notificationId', pref.notificationId);
                var col = Object.keys(channels).length + 2;
                expand.classList.add('notificationapi-preferences-expand', "notificationapi-preferences-col".concat(col), "notificationapi-preferences-row".concat(row - 1));
                expand.addEventListener('click', function (e) {
                    var expand = e.target;
                    var notificationId = expand.getAttribute('data-notificationId');
                    popup
                        .querySelectorAll("[data-notificationId=\"".concat(notificationId, "\"][data-subNotificationId]"))
                        .forEach(function (e) {
                        e.classList.toggle('closed');
                    });
                });
                grid.appendChild(expand);
                pref.subNotificationPreferences.map(function (subPref) {
                    var title = document.createElement('div');
                    title.classList.add('notificationapi-preferences-subtitle', 'notificationapi-preferences-col1', "notificationapi-preferences-row".concat(row), 'closed');
                    title.setAttribute('data-subNotificationId', subPref.subNotificationId);
                    title.setAttribute('data-notificationId', pref.notificationId);
                    title.innerHTML = subPref.title;
                    grid.appendChild(title);
                    subPref.settings.map(function (s) {
                        var toggle = document.createElement('div');
                        var col = Object.keys(channels).indexOf(s.channel) + 2;
                        toggle.classList.add('notificationapi-preferences-subtoggle', "notificationapi-preferences-col".concat(col), "notificationapi-preferences-row".concat(row), 'closed');
                        toggle.setAttribute('data-notificationId', subPref.notificationId);
                        toggle.setAttribute('data-subNotificationId', subPref.subNotificationId);
                        toggle.setAttribute('data-channel', s.channel);
                        var label = document.createElement('label');
                        label.classList.add('switch', 'small');
                        toggle.appendChild(label);
                        var input = document.createElement('input');
                        input.setAttribute('type', 'checkbox');
                        input.checked = s.state;
                        if (pref.settings.find(function (ps) { return ps.channel === s.channel && ps.state === false; }))
                            input.disabled = true;
                        label.appendChild(input);
                        var i = document.createElement('i');
                        label.appendChild(i);
                        input.addEventListener('change', function () {
                            _this.patchUserPreference(pref.notificationId, s.channel, input.checked, subPref.subNotificationId);
                        });
                        grid.appendChild(toggle);
                    });
                    row++;
                });
            }
        });
    };
    NotificationAPIClient.prototype.renderWebPushOptIn = function () {
        var _this = this;
        var localStorageAskForWebPushPermission = JSON.parse(localStorage.getItem('askForWebPushPermission') || 'true');
        if (!this.elements.header || !localStorageAskForWebPushPermission) {
            return;
        }
        var optInContainer = document.createElement('div');
        optInContainer.classList.add('notificationapi-opt-in-container');
        var optInMessage = document.createElement('div');
        optInMessage.innerHTML = 'Do you want to receive push notifications?';
        optInMessage.classList.add('notificationapi-opt-in-message');
        optInContainer.appendChild(optInMessage);
        var allowButton = document.createElement('button');
        allowButton.innerHTML = 'Yes';
        allowButton.classList.add('notificationapi-allow-button');
        allowButton.addEventListener('click', function () {
            _this.askForWebPushPermission();
            localStorage.setItem('askForWebPushPermission', 'false');
            optInContainer.style.display = 'none';
        });
        optInContainer.appendChild(allowButton);
        var noThanksButton = document.createElement('button');
        noThanksButton.innerHTML = 'No, thanks';
        noThanksButton.classList.add('notificationapi-no-thanks-button');
        noThanksButton.addEventListener('click', function () {
            localStorage.setItem('askForWebPushPermission', 'false');
            optInContainer.style.display = 'none';
        });
        optInContainer.appendChild(noThanksButton);
        this.elements.header.appendChild(optInContainer);
    };
    NotificationAPIClient.prototype.sendWSMessage = function (request) {
        if (!this.websocket)
            return;
        var ws = this.websocket;
        if (ws.readyState == ws.OPEN) {
            ws.send(JSON.stringify(request));
        }
        else {
            ws.addEventListener('open', function () {
                ws.send(JSON.stringify(request));
            });
        }
    };
    NotificationAPIClient.prototype.websocketMessageReceived = function (route) {
        return __awaiter(this, void 0, void 0, function () {
            var ws;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.websocketOpened()];
                    case 1:
                        ws = _a.sent();
                        return [2, new Promise(function (resolve) {
                                ws.addEventListener('message', function (message) {
                                    var body = JSON.parse(message.data);
                                    if (body && body.route && body.route === route) {
                                        resolve(body);
                                    }
                                });
                            })];
                }
            });
        });
    };
    NotificationAPIClient.prototype.websocketOpened = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!_this.websocket)
                reject('Websocket is not present.');
            else {
                var ws = _this.websocket;
                if (ws.readyState == ws.OPEN) {
                    resolve(ws);
                }
            }
        });
    };
    return NotificationAPIClient;
}());
export default NotificationAPIClient;
